import React from 'react';
import {connect} from 'react-redux';
import Const from 'constants';
import {filterObjectByParams, sortArrayOfObjects} from 'helpers/common-helper';
import {PlayersList as BasePlayersList} from 'components/organisms/used-players-list/components/players-list';
import PlayerExposure from 'components/molecules/player-exposure';
import PlayerPoints from 'components/molecules/player-points';
import PlayerLock from 'components/molecules/player-lock';
import PlayerLocksList from 'components/molecules/player-lock/player-locks-list';
import RankPlayerExclusionState from 'components/molecules/player-exclusion/rank-player-exclusion-state';
import PlayerExposureSummary from 'components/organisms/used-players-list/components/player-exposure-summary';
import TeamLogo from 'components/molecules/team-logo';
import FilterLineupsByPlayerAndMode from 'components/molecules/filter-lineups-by-player/filter-lineups-by-player-and-mode';
import PlayerInjury from 'components/molecules/player-injury';

class PlayersListComponent extends BasePlayersList {
    getPlayers() {
        const {filters} = this.props;

        const filteredPlayers = this.getFilteredUsedPlayers();

        if (isEmpty(filteredPlayers)) {
            return [];
        }

        let players = [];
        if (Const.PLAYERS_SINGLEGAME_FILTER_ALL === filters.singleGame) {
            let assocList = {};
            filteredPlayers.map((player) => {
                if (!assocList.hasOwnProperty(player.getId())) {
                    assocList[player.getId()] = {...player};
                    assocList[player.getId()].setAsCaptain();
                } else {
                    assocList[player.getId()].usedLineupsCount += player.usedLineupsCount;
                }
            });
            players = Object.values(assocList);
        } else {
            let searchParams = {
                lineupRole: {
                    filterType: Const.FILTER_TYPE_EQUAL,
                    filterValue: filters.singleGame,
                },
            };
            players = filterObjectByParams(filteredPlayers, searchParams, true);
        }

        return sortArrayOfObjects(players, 'usedLineupsCount', 'desc');
    }

    render() {
        const {sportConfig, filters} = this.props;

        const players = this.getPlayers();
        const renderKey = this.getRenderKey();

        const items = [];
        if (!isEmpty(players)) {
            Object.values(players).map((player, index) => {
                const className = index % 2 === 0 ? 'even' : '';

                items.push(
                    <tbody key={`${renderKey}${index}`} className={className}>
                        <tr>
                            <td colSpan="5" className="top-line">
                                <RankPlayerExclusionState
                                    activeMode={filters.singleGame}
                                    playerMode={filters.singleGame}
                                    playerId={player.getId()}
                                />
                                <FilterLineupsByPlayerAndMode player={player} activeMode={filters.singleGame} />
                                {super.isRankMode(filters.singleGame) ? (
                                    <PlayerLock
                                        className={`lock-player lock-btn`}
                                        playerId={player.getId()}
                                        mode={filters.singleGame}
                                    />
                                ) : (
                                    <PlayerLocksList playerId={player.getId()} />
                                )}
                                <TeamLogo teamName={player.team.toUpperCase()} />
                                <div className="player">
                                    <div>
                                        <span className="pos">{player.positionName.toUpperCase()}</span>
                                        <div className="name">
                                            {player.name}
                                            <PlayerInjury player={player} />
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {this.wrapContentInTooltip(
                                    <PlayerPoints
                                        className="form-control xs-table-input"
                                        playerId={player.getId()}
                                        mode={filters.singleGame}
                                        propName={'userPoints'}
                                    />,
                                    `Default Score: ${player.getPropValueOfMode('adminPoints', filters.singleGame)}`,
                                )}
                            </td>
                            <td className="text-blue">
                                <span className="inline-text">{this.calcPlayerExposure(player)}%</span>(
                                {this.calcPlayerLineupsQuantity(player)})
                            </td>
                            <td>{player.projOwn.getValue(filters.singleGame)}</td>
                            <td className="td-exp alt">
                                <div className="percent-in">
                                    <PlayerExposure
                                        className="form-control"
                                        playerId={player.getId()}
                                        propName={'exposureMin'}
                                        mode={filters.singleGame}
                                    />
                                    <span className="percent">%</span>
                                </div>
                            </td>
                            <td className="td-exp alt">
                                <div className="percent-in">
                                    <PlayerExposure
                                        className="form-control"
                                        playerId={player.getId()}
                                        propName={'exposureMax'}
                                        mode={filters.singleGame}
                                    />
                                    <span className="percent">%</span>
                                </div>
                            </td>
                        </tr>

                        {Const.PLAYERS_SHOWDOWN_FILTER_ALL === filters.singleGame ? (
                            <tr key={`${renderKey}${index}-1`}>
                                <td colSpan="5" className="bottom-line">
                                    <PlayerExposureSummary
                                        sport={Const.LEAGUE_NFL}
                                        site={sportConfig.getSite()}
                                        gameType={Const.GAME_TYPE_SINGLEGAME}
                                        playerId={player.getId()}
                                    />
                                </td>
                            </tr>
                        ) : null}
                    </tbody>,
                );
            });
        } else {
            items.push(this.getTBodyPlayersNotFoundView({colSpan: 5}));
        }

        return (
            <div className="players-used-table table-holder">
                <div className="sticky-table">
                    <table className="players-table">
                        <tbody>
                            <tr>
                                <th>FPts</th>
                                <th>Exp%</th>
                                <th>ProjOwn</th>
                                <th>Exp.min</th>
                                <th>Exp.max</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <table className="players-table">{items}</table>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        usedPlayers,
        filterLineupsByPlayer,
        lineupsData: {lineups},
    } = state;

    return {
        sportConfig,
        usedPlayers: usedPlayers.players,
        filters: usedPlayers.filters,
        filterLineupsByPlayer,
        lineups,
    };
}

const PlayersList = connect(mapStatesToProps)(PlayersListComponent);

export {PlayersList};
